import {
  CanDeleteSpaceTypeEnum,
  IWorksheetState,
} from 'spw-redux/modules/worksheet/types';
import {
  Actions,
  FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW,
  FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW_SUCCESS,
  SET_IS_SPACE_TYPE_DELETABLE,
  SET_REMOVE_SPACE_TYPE_DIALOG_STATUS,
  SET_SELECTED_SPACE_TYPE,
  SET_SELECTED_CHILD_SPACE_TYPE,
  SET_SELECTED_WORKSHEET_ROW,
  SET_WORKSHEET_DECIMALS_ARE_ENABLED,
  SET_SELECTED_SPACE_TYPE_CATEGORY,
  FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY_SUCCESS,
} from 'spw-redux/modules/worksheet/actions';

const initialState: IWorksheetState = {
  canDeleteSpaceType: CanDeleteSpaceTypeEnum.FALSE,
  selectedRow: null,
  selectedSpaceTypeCategory: null,
  selectedSpaceType: null,
  selectedChildSpaceType: null,
  scenariosUsingSpaceTypeOrCategory: [],
  worksheetsUsingSpaceTypeOrCategory: {
    byId: {},
  },
  showRemoveSpaceTypeDialog: false,
  hideAllMode: false,
  decimalsAreEnabled: true,
};

const reducer = (state: IWorksheetState = initialState, action: Actions) => {
  switch (action.type) {
    case SET_WORKSHEET_DECIMALS_ARE_ENABLED: {
      return {
        ...state,
        decimalsAreEnabled: action.payload,
      };
    }
    case SET_IS_SPACE_TYPE_DELETABLE: {
      return {
        ...state,
        canDeleteSpaceType: action.payload.canDeleteSpaceType
          ? CanDeleteSpaceTypeEnum.TRUE
          : CanDeleteSpaceTypeEnum.FALSE,
      };
    }

    case FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW: {
      return {
        ...state,
        canDeleteSpaceType: CanDeleteSpaceTypeEnum.QUERYING,
      };
    }

    case FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_ROW_SUCCESS:
    case FETCH_SCENARIOS_ASSOCIATED_WITH_SELECTED_CATEGORY_SUCCESS: {
      return {
        ...state,
        scenariosUsingSpaceTypeOrCategory:
          action.payload.scenariosUsingSpaceTypeOrCategory,
        worksheetsUsingSpaceTypeOrCategory:
          action.payload.worksheetsUsingSpaceTypeOrCategory,
      };
    }

    case SET_REMOVE_SPACE_TYPE_DIALOG_STATUS: {
      return {
        ...state,
        showRemoveSpaceTypeDialog: action.payload.status,
        hideAllMode: action.payload.hideAllMode,
      };
    }

    case SET_SELECTED_WORKSHEET_ROW: {
      return {
        ...state,
        selectedRow: action.payload.row,
      };
    }

    case SET_SELECTED_SPACE_TYPE_CATEGORY: {
      return {
        ...state,
        selectedSpaceTypeCategory: action.payload.spaceTypeCategory,
        selectedSpaceType: null,
        selectedChildSpaceType: null,
      };
    }

    case SET_SELECTED_SPACE_TYPE: {
      return {
        ...state,
        selectedSpaceType: action.payload.spaceType,
        selectedSpaceTypeCategory: null,
        selectedChildSpaceType: null,
      };
    }

    case SET_SELECTED_CHILD_SPACE_TYPE: {
      return {
        ...state,
        selectedChildSpaceType: action.payload.childSpaceType,
        selectedSpaceTypeCategory: null,
        selectedSpaceType: null,
      };
    }

    default:
      return state;
  }
};

export default reducer;
